import { message } from 'ant-design-vue';
import type { UseClipboardReturn } from '@vueuse/core';

let clipboardInstance: UseClipboardReturn<boolean> | null = null;
// 懒加载 useClipboard
async function getClipboard() {
  if (clipboardInstance) {
    return clipboardInstance;
  }

  const { useClipboard } = await import('@vueuse/core');
  clipboardInstance = useClipboard({ legacy: true });
  return clipboardInstance;
}

export async function copyText(text: string, prompt: string | null = '已成功复制到剪切板!') {
  const clipboard = await getClipboard();
  if (!clipboard.isSupported.value) {
    return Promise.reject(
      `"navigator.clipboard" 或 "document.execCommand" 中存在API错误, 拷贝失败!`,
    );
  }

  return clipboard
    .copy(text)
    .then(() => {
      prompt && message.success(prompt);
    })
    .catch((error) => {
      message.error('复制失败!' + error.message);
    });
}

export async function readText(): Promise<string> {
  const clipboard = await getClipboard();
  return new Promise((resolve) => resolve(clipboard.text.value || ''));
}

export async function readJsonText() {
  try {
    const clipboardText = await readText();
    return JSON.parse(clipboardText);
  } catch {}
}
